import axios from "axios";
import UserUtils from "../../../basecomp/auth/UserUtils";
import AxiosWrapper from "../../../basecomp/base/AxiosWrapper";

const {
  axiosGetCallHeaderWithToken,
  axiosGetCallWithToken
} = AxiosWrapper;
const currentUrl = window.location.origin;

const apiKey = "x-api-key";
const {  getTokenFromEmail } = UserUtils;

const getBEUrl = () => {
  const data = localStorage.getItem("permissionData");
  const isUAT = data !== undefined && data !== null && data.includes("feature_uat");
  let REACT_APP_BE_URL = isUAT ? process.env.REACT_APP_BE_URL2 : process.env.REACT_APP_BE_URL;
  return REACT_APP_BE_URL;
}


export const uploadAssetDetailsData = async (selectedSizeId, selectedFiles) => {
  const formData = new FormData();
  formData.append("selectedSizeId", selectedSizeId);
  formData.append("filType", 'details');
  
  for (let i = 0; i < selectedFiles.length; i++) {
    formData.append("file", selectedFiles[i]);
  }

  try {
    const token = getTokenFromEmail();
    const response =  await axios.post(`${getBEUrl()}/asset_it/assetFileUploads`, formData, {
      headers: {
        [apiKey]: token,
      },
    });
    return response;
  } catch (error) {
    // Re-throw the error with more context if needed
    throw error;
  }
};

export const fetchSizeOptions = async () => {
  const response = await axiosGetCallWithToken(
    `/label_print/getAllMeasurement`
  );
  return response;
};

export const getSampleUploadFile = async (type) => {
  const response = await axiosGetCallHeaderWithToken(
    `/asset_it/asset-sample-file?type=${type}`,
    "text/csv"
  );
  return response;
};


// Export assets to Excel (from backend), newest first
export const exportAssets = async (search, includeRetired = false, filters = {}) => {
  const tz = Intl.DateTimeFormat().resolvedOptions().timeZone; // browser time zone, e.g. Asia/Kolkata
  const response = await axiosGetCallHeaderWithToken(
    `/asset_it/asset-export?search=${encodeURIComponent(search || "")}&tz=${encodeURIComponent(
      tz
    )}&retired_only=${includeRetired ? "true" : "false"}` +
      `&status=${encodeURIComponent(filters.status || "")}` +
      `&category=${encodeURIComponent(filters.category || "")}` +
      `&employee=${encodeURIComponent(filters.employee || "")}`,
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
  );
  return response;
};

// Fetch all assets
export const fetchAssets = async (includeRetired = false) => {
  try {
    const response = await axiosGetCallWithToken(
      `/asset_it/all-asset?retired_only=${includeRetired ? "true" : "false"}`
    ); 
    return response;
  } catch (error) {
    throw new Error(error.response?.data?.message);
  }
};

// Get asset PDF for view/print
// sizeId / saveSize: size chosen in the "Choose sticker size" popup (optional)
export const getAssetPdf = async (id, type, sizeId, saveSize) => {
  const idParam = id === undefined ? `` : `&id=${id}`;
  const sizeParam = sizeId
    ? `&size_id=${encodeURIComponent(sizeId)}&save_size=${saveSize ? "true" : "false"}`
    : "";

  const response = await axiosGetCallHeaderWithToken(
    `/asset_it/asset-pdf?type=${type}&url=${currentUrl}${idParam}${sizeParam}`,
    "application/pdf"
  );
  return response;
};

// The PDF call gets a file back, so an error message comes back as a file too.
// This reads it as normal JSON: { status, data }
export const readPdfError = async (error) => {
  let data = error?.response?.data;
  try {
    if (typeof Blob !== "undefined" && data instanceof Blob) {
      data = JSON.parse(await data.text());
    } else if (data instanceof ArrayBuffer) {
      data = JSON.parse(new TextDecoder().decode(data));
    } else if (typeof data === "string") {
      data = JSON.parse(data);
    }
  } catch (e) {
    data = null;
  }
  return { status: error?.response?.status, data };
};
// Register one asset from the "Single Asset" form
export const registerSingleAsset = async (assetData) => {
  const token = getTokenFromEmail();
  const response = await axios.post(
    `${getBEUrl()}/asset_it/register-asset`,
    assetData,
    {
      headers: {
        [apiKey]: token,
        "Content-Type": "application/json",
      },
    }
  );
  return response;
};

// Dropdown suggestions (categories, brands, OS...) for the "Single Asset" form
export const fetchAssetFormOptions = async () => {
  const token = getTokenFromEmail();
  const response = await axios.get(`${getBEUrl()}/asset_it/asset-form-options`, {
    headers: {
      [apiKey]: token,
    },
  });
  return response;
};


// ---------- Employee Assets (employee leaving) ----------

// Employees who have at least one asset right now
export const fetchAssetHolders = async () => {
  const token = getTokenFromEmail();
  const response = await axios.get(`${getBEUrl()}/asset_it/asset-holders`, {
    headers: { [apiKey]: token },
  });
  return response;
};

// Everything one employee has right now
export const fetchEmployeeAssets = async (employeeName, employeeCode) => {
  const token = getTokenFromEmail();
  const response = await axios.get(
    `${getBEUrl()}/asset_it/employee-assets?employee_name=${encodeURIComponent(
      employeeName || ""
    )}&employee_code=${encodeURIComponent(employeeCode || "")}`,
    { headers: { [apiKey]: token } }
  );
  return response;
};

// Return many assets of one employee in one go
export const returnAllAssets = async (body) => {
  const token = getTokenFromEmail();
  const response = await axios.put(`${getBEUrl()}/asset_it/return-all`, body, {
    headers: { [apiKey]: token, "Content-Type": "application/json" },
  });
  return response;
};


// ---------- Dashboard ----------
// Totals, by category and warranty expiring in the next `days` days
export const fetchDashboard = async (days = 30) => {
  const token = getTokenFromEmail();
  const response = await axios.get(`${getBEUrl()}/asset_it/asset-dashboard?days=${days}`, {
    headers: { [apiKey]: token },
  });
  return response;
};